export default __webpack_public_path__ + "static/media/OmaOpa.acdfc83c.png";